<template>
  <div class="kp-flat-card dark">
    <div class="row">
      <div class="col-xl-6">
        <div class="row">
          <div class="col-md-12">
            <h4 class="h5 font-weight-normal mb-30">Today's facts</h4>
          </div>
          <div class="col-6">
            <div class="daily-fact has-symbol">
              <p><sup>€</sup> 1,234</p>
              <h5>Transactions</h5>
            </div>
          </div>
          <div class="col-6">
            <div class="daily-fact has-symbol">
              <p><sup>€</sup> 58,123</p>
              <h5>Orders value</h5>
            </div>
          </div>
          <div class="col-6">
            <div class="daily-fact mb-0">
              <p>16</p>
              <h5>New Merchants</h5>
            </div>
          </div>
          <div class="col-6">
            <div class="daily-fact mb-0">
              <p>485</p>
              <h5>Active Merchants</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 position-relative">
        <div class="mt-90 d-lg-none"></div>
        <binary-animation></binary-animation>
        <apexchart class="income-chart" ref="incomeChart" type=radialBar height=270 width=270 :options="chartOptions" :series="series" />
      </div>
    </div>
  </div>
</template>

<script>
import BinaryAnimation from '@/components/dashboard/BinaryAnimation.vue'

export default {
  name: 'today-facts',
  components: {
    BinaryAnimation
  },
  data() {
    return {
      series: [73],
      chartOptions: {
        chart: {
          fontFamily: '"Catamaran", Helvetica, Arial, sans-serif',
        },
        legend: {
          show: false
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '75%'
            },
            dataLabels: {
              name: {
                fontSize: '18px',
                color: '#ffffff'
              },
              value: {
                fontSize: '21px',
                color: '#ffffff'
              }
            },
            track: {
              background: '#000',
              opacity: 0.2,
              strokeWidth: '60%'
            }
          },
        },
        colors: ['#EF7816'],
        labels: ['Daily target'],
        stroke: {
          lineCap: 'round'
        }
      }
    }
  }
}
</script>
